import React from 'react'
import flowRight from 'lodash/flowRight'
import withCondition from 'loankeeper-common/containers/withCondition'
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import LKButton from 'shared/LKButton'
import { useGridApi } from './LKGridInstance/components/gridApi'

function isDisabled(gridApi) {
  if (!gridApi) {
    return true
  }

  return gridApi?.api?.getModel()?.rowsToDisplay?.length === 0
}

const ExportButton = ({ instanceName, className, caption, type }) => {
  const gridApi = useGridApi(instanceName)

  return (
    <LKButton
      alias="export"
      className={className}
      onClick={() => {
        if (gridApi) {
          gridApi.api.exportDataAsExcel()
        }
      }}
      disabled={isDisabled(gridApi)}
      type={type}
    >
      {caption}
    </LKButton>
  )
}

export default flowRight(
  withConstantPermissions(['EXPORT_DATA']),
  withCondition(
    ({ EXPORT_DATA }) => EXPORT_DATA,
    () => null,
  ),
)(ExportButton)
